export class AssetPresetFieldsModel {

  uid: number;
  name: string;
  defaultValues: any;

  constructor() {


  }
}